// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32grS","fullView":"styles_fullView__3OlK8"};